import { render, staticRenderFns } from "./MarketingContact.vue?vue&type=template&id=5fd0d3ca&"
import script from "./MarketingContact.vue?vue&type=script&lang=ts&"
export * from "./MarketingContact.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports